<!--表单页面拷贝开始-->
<template>
  <div>
    <form-components @submitForm="submitForm">
      <template v-slot:content>
        <el-form-item label="名称">
          <el-col :span="8">
            <el-input v-model="sysRobot.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="编号">
          <el-col :span="8">
            <el-input v-model="sysRobot.robotId"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="请求地址">
          <el-col :span="8">
            <el-input v-model="sysRobot.url"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="放置位置">
          <el-col :span="8">
            <el-input v-model="sysRobot.groupName"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-col :span="8">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="sysRobot.remark"
            >
            </el-input>
          </el-col>
        </el-form-item>
      </template>
    </form-components>



  </div>
</template>

<script>
import FormComponents from "@/components/form/FormComponents";
import SysRobotApi from "@/api/SysRobotApi";
import { navTo, queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "SaveSysRobotPage",
  props: {
    msg: String,
  },
  components: {
    FormComponents,
  },
  data() {
    return {
      sysRobot: {
        name: "",
        url: "",
        remark: "",
        robotId: "",
        id: 0,
        groupName:""
      },
    };
  },
  created() {
    this.sysRobot = this.$route.params;
  },
  methods: {
    submitForm() {
      this.sysRobot.id > 0 ? this.updateSysRobotById() : this.addSysRobot();
    },
    addSysRobot() {
      SysRobotApi.saveSysRobot(this.sysRobot).then((resp) => {
        if (resp.state == "OK") {
          this.sysRobot = {};
          this.$successMsg(resp.msg);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    updateSysRobotById() {
      SysRobotApi.updateSysRobot(this.sysRobot).then((resp) => {
        if (resp.state == "OK") {
          this.user = {};
          this.$successMsg(resp.msg);
          navTo(this, "/sysRobotList");
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
  },
};
</script>
<!--表单页面拷贝结束-->